import { Box, styled, Typography } from '@mui/material';

export const NextStepNodeTextBox = styled(Box)(({ theme }) => ({
    borderRadius: '12px',
    padding: '16px',
    height: '100%',
    background:
        'linear-gradient(171deg, rgba(58, 98, 227, 0.18) 0%, rgba(89, 184, 202, 0.18) 100%)',
    boxShadow: '9px 8px 41px 0px rgba(0, 0, 0, 0.59)',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    gap: theme.spacing(1),
}));

export const TextAreaNextStepLabel = styled(Typography)({
    fontSize: '17px',
    fontWeight: 600,
});

export const NextStepIcon = styled(Box)(({ theme }) => ({
    minWidth: 50,
    minHeight: 50,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

export const NextStepText = styled(Typography)({
    fontSize: 20,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
});
